<script setup>
import { onUpdated, ref} from "vue";
import {useComStore, useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
const props = defineProps(['grpCode', 'readonly'])
const comStore = useComStore()
const groupCodes = ref(comStore.getGroupCodes);
const selectedGroup =ref();
const emits = defineEmits([
    'set_grpCode'
])
const updateMenu = (value)=>{
  emits('set_grpCode', value);
}

onUpdated(()=>{
  if(props.grpCode){
    selectedGroup.value=props.grpCode;
  }
})
</script>

<template>
  <v-select
      v-model="selectedGroup"
      @update:modelValue="updateMenu"
      :items="groupCodes"
      :readonly="readonly"
      :placeholder="languageStore.get('select')"
      variant="outlined"
      density="compact"
      hide-details="auto"
  />
</template>

<style scoped>

</style>